import React, { useEffect, useState, useRef } from "react";
import { fetchActiveAnnouncements } from "./announcementService";

const ROTATION_INTERVAL = 5000;
const BLINK_INTERVAL = 700;

const AnnouncementBar = () => {
  const [announcements, setAnnouncements] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [visible, setVisible] = useState(true);
  const [blink, setBlink] = useState(true);

  const rotationRef = useRef(null);
  const blinkRef = useRef(null);

  useEffect(() => {
    fetchAnnouncements();
    return () => { stopRotation(); stopBlinking(); };
  }, []);

  useEffect(() => {
    if (announcements.length > 1) startRotation();
    return () => stopRotation();
  }, [announcements]);

  useEffect(() => {
    if (announcements.length > 0) startBlinking();
    return () => stopBlinking();
  }, [announcements, currentIndex]);

  const fetchAnnouncements = async () => {
    try {
      const response = await fetchActiveAnnouncements();
      if (!response.success) { setAnnouncements([]); return; }
      const data = response.data;
      if (!Array.isArray(data) || data.length === 0) { setAnnouncements([]); return; }
      setAnnouncements([...data].sort((a, b) => b.priority - a.priority));
    } catch {
      setAnnouncements([]);
    }
  };

  const startRotation = () => {
    stopRotation();
    rotationRef.current = setInterval(() => {
      setCurrentIndex(prev => (prev + 1) % announcements.length);
    }, ROTATION_INTERVAL);
  };

  const stopRotation = () => {
    if (rotationRef.current) { clearInterval(rotationRef.current); rotationRef.current = null; }
  };

  const startBlinking = () => {
    stopBlinking();
    blinkRef.current = setInterval(() => setBlink(prev => !prev), BLINK_INTERVAL);
  };

  const stopBlinking = () => {
    if (blinkRef.current) { clearInterval(blinkRef.current); blinkRef.current = null; setBlink(true); }
  };

  const closeBar = () => { setVisible(false); stopRotation(); stopBlinking(); };

  if (!visible || announcements.length === 0) return null;

  const current = announcements[currentIndex];

  // Build href: prefer whatsappNumber → wa.me link, else use link field
  const href = current.whatsappNumber
    ? `https://wa.me/${current.whatsappNumber.replace(/\D/g, "")}`
    : current.link || null;

  const barInner = (
    <div
      style={{
        background: current.backgroundColor || "#0d6efd",
        color: current.textColor || "#ffffff",
        padding: "10px 16px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        fontSize: "14px",
        fontWeight: "500",
        opacity: blink ? 1 : 0.3,
        transition: "opacity 0.3s ease-in-out",
        cursor: href ? "pointer" : "default",
      }}
    >
      <div style={{ flex: 1, textAlign: "center" }}>
        {current.message}
      </div>
      <button
        onClick={(e) => { e.preventDefault(); e.stopPropagation(); closeBar(); }}
        style={{
          background: "transparent",
          border: "none",
          color: current.textColor || "#ffffff",
          fontSize: "18px",
          cursor: "pointer",
          marginLeft: "10px",
          lineHeight: 1,
          position: "relative",
          zIndex: 1002,
        }}
      >
        ×
      </button>
    </div>
  );

  return href ? (
    <a href={href} target="_blank" rel="noopener noreferrer" style={{ textDecoration: "none", display: "block", position: "relative", zIndex: 1001 }}>
      {barInner}
    </a>
  ) : <div style={{ position: "relative", zIndex: 1001 }}>{barInner}</div>;
};

export default AnnouncementBar;
